<template>
  <div ref="target">
    <slot />
  </div>
</template>

<script>
import gsap from 'gsap';
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export default {
  mounted() {
    this.animate();
  },
  methods: {
    animate() {
      let mm = gsap.matchMedia();
      const target = this.$refs.target;

      const overlay = target.querySelector('.collage-hero__overlay');
      const main = target.querySelector('.collage-hero__main');
      const contexts = target.querySelectorAll('.hero .context');
      const overlayTexts = target.querySelectorAll('.collage-hero__overlay .context__heading > span > span > span');

      // gsap.to(
      //   overlay,
      //   {
      //     scrollTrigger: {
      //       trigger: target,
      //       toggleActions: 'restart none none reverse',
      //       start: 'top',
      //       scrub: 2,
      //       pin: true,
      //     },
      //     backgroundColor: 'rgba(0, 0, 0, 0.0)',
      //   }
      // )

      // gsap.to(
      //   main,
      //   {
      //     scrollTrigger: {
      //       trigger: overlay,
      //       toggleActions: 'restart none none reverse',
      //       start: 'top',
      //       scrub: 1,
      //       markers: true,
      //     },
      //     scale: 1,
      //   }
      // )

      contexts.forEach((context) => {
        gsap.to(
          context,
          {
            scrollTrigger: {
              trigger: overlay,
              toggleActions: 'restart none none reverse',
              start: 'top',
              // markers: true,
            },
            duration: 0.1,
            opacity: 1,
          }
        )
      });
    }
  }
}
</script>